export default function PolicyStatusSwitch({
  checked,
  disabled,
  onChange,
}: {
  checked: boolean
  disabled: boolean
  onChange: (enabled: boolean) => void
}) {
  return (
    <div className="flex items-center justify-between gap-3">
      <span className="text-xs text-gray-600">Policy status</span>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label="Policy status"
        disabled={disabled}
        className={`relative inline-flex h-5 w-9 shrink-0 items-center rounded-full border transition ${
          checked ? 'border-brand-600 bg-brand-600' : 'border-gray-300 bg-gray-200'
        } ${disabled ? 'opacity-50' : ''}`}
        onClick={() => onChange(!checked)}
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white transition ${
            checked ? 'translate-x-4' : 'translate-x-0.5'
          }`}
        />
      </button>
    </div>
  )
}
